import React from 'react';
import Row from "../../../../core/layout/Row";
import Column from "../../../../core/layout/Column";
import TextInput from "../../../../core/form/TextInput";
import PropTypes from "prop-types";
import FormButtons from "../../../../core/form/FormButtons";
import get from "lodash/get";

const SystemTranslationLocaleForm = (props) => (
    <form onSubmit={(event) => {
        event.preventDefault();
        props.onSubmit();
    }}>
        <Row>
            <Column
                size={12}>
                <TextInput
                    required
                    label="Key"
                    value={get(props.values, 'key', '')}
                    onChange={value => props.onChange('key', value)}
                    disabled={props.submitting || get(props.values, 'id', '')}
                    errorText={get(props.errors, 'key', null)}
                />
            </Column>
        </Row>
        <Row>
            <Column
                size={12}>
                <TextInput
                    required
                    label="Language"
                    value={get(props.values, 'language', '')}
                    onChange={value => props.onChange('language', value)}
                    disabled={props.submitting}
                    errorText={get(props.errors, 'language', null)}
                />
            </Column>
        </Row>
        <Row>
            <FormButtons
                confirmLabel={get(props.values, 'id', '') ? 'Update Locale' : 'Create Locale'}
                isDisabled={props.submitting || !props.isDirty()}
                isSubmitting={props.submitting}
                onReset={props.onReset}
            />
        </Row>
    </form>
);

SystemTranslationLocaleForm.propTypes = {
    onSubmit: PropTypes.func,
    onReset: PropTypes.func.isRequired,
    values: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.object,
    submitting: PropTypes.bool,
    isDirty: PropTypes.func,
};

SystemTranslationLocaleForm.defaultProps = {
    values: {},
    errors: {},
    submitting: false,
    isDirty: () => false,
    onSubmit: () => alert('submitted'),
    onReset: () => false,
};

export default SystemTranslationLocaleForm;